import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
/**
    * Loads the Local Languages with appropriate options.
    *
    *See {@link LocalizedCurrencyPipe} for details.
     */
@Injectable()
export class CustomTranslateService {

/**
    * Adds the required Local Languages.
     */
    constructor(private translate: TranslateService) {
        translate.addLangs(['en', 'es']);
        translate.setDefaultLang('en');
        const browserLang = translate.getBrowserLang();
        translate.use(browserLang.match(/en|es/) ? browserLang : 'en');

    }

/**
    /**This fuction used to set the default language */
    SetDefaultLang(Lang: string) {
        this.translate.setDefaultLang(Lang);
    }

    /**This function used to switch the language  */
    switchLanguage(language: string) {
        this.translate.setDefaultLang(language);
        this.translate.use(language);

    }
    /**This function used to get the current language */
    getCurrentLanguage(): string {
        return this.translate.currentLang;
    }

    /**This function used to get the currency code */
    getCurrencyCode(): string {
        switch (this.translate.currentLang) {
            case 'en':
                return 'USD';
            case 'es':
                return 'EUR';
            default:
                return 'USD';
        }
    }
}



// import { Injectable } from '@angular/core';
// import { Headers, Http, Response } from "@angular/http";
// import { TranslateLoader } from '@ngx-translate/core';
// import { AppConfig } from "./config"
// import {Observable} from 'rxjs/Observable'; 


// @Injectable()
// export class CustomTranslateLoader implements TranslateLoader  {
//     contentHeader = new Headers({"Content-Type": "application/json","Access-Control-Allow-Origin":"*"});

//     constructor(private http: Http) {}
//     getTranslation(lang: string): Observable<any>{
//         var apiAddress = AppConfig.API_URL+"/static/i18n/"+ lang+".json";
//         return Observable.create(observer => {
//           this.http.get(apiAddress, { headers: this.contentHeader }).subscribe((res: Response) => {
//                     observer.next(res.json());
//                     observer.complete();               
//                 },
//             error => {
//                 //  failed to retrieve from api, switch to local
//                 this.http.get("/assets/i18n/en.json").subscribe((res: Response) => {
//                     observer.next(res.json());
//                     observer.complete();               
//                 })
//             }
//             );
//         }); 
//     }
// }
